import React from 'react';
import {Link} from 'react-router-dom';
import mainLogo from './images/kofer.png'
import velikiBal from './images/velikiBal.jpg'
import telefon from './images/telephone.png'
import bigColud from './images/bigCloud.webp'

function Početna() {
  return (
    <div className='mainContainer'>
  <header className='headerMainLogo'>
    <img src={mainLogo} alt='logo' className='mainLogo'></img>
    <div className='navBarContainer'>
      <img src={bigColud} className='bigCloud'></img>
    </div>

    <img src={velikiBal} alt='velikiBal' className='middlePicture'></img>
    </header>
    </div> 
  );
}

export default Početna;